const EmailValidation = (email: string): Boolean => {
	return /\S+@\S+\.\S+/.test(email);
};

export default EmailValidation;
